import React from 'react'
import { Navigate } from 'react-router-dom';
import { useSessionContext } from '../contexts/SessionContext';

export default function useRouteGuard(children?: JSX.Element, can?: boolean, redirectPath?: string): JSX.Element {
    const sessionContext = useSessionContext();
    const isSigned: boolean = (sessionContext.session?.signed &&
        Boolean(sessionContext.session.user?.token)) ?? false;

    let toPath = isSigned ? (redirectPath ?? '/') : "/auth/login";

    if (isSigned && (can ?? true))
        toPath = "/home";

    return ((isSigned && (can ?? true)) ? (children ?? <></>) : <Navigate to={toPath} />)
}